function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.25 15.4167C2.70833 14.7917 0 11.7083 0 8C0 3.875 3.375 0.5 7.5 0.5C11.625 0.5 15 3.875 15 8C15 11.7083 12.2917 14.7917 8.75 15.4167L8.33333 15.0833H6.66667L6.25 15.4167Z",
  fill: "url(#paint0_linear_619_32901)"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M10.4167 10.0833L10.75 8.00001H8.75V6.54167C8.75 5.95834 8.95833 5.50001 9.875 5.50001H10.8333V3.58334C10.2917 3.50001 9.70833 3.41667 9.16667 3.41667C7.45833 3.41667 6.25 4.45834 6.25 6.33334V8.00001H4.375V10.0833H6.25V15.375C6.66667 15.4583 7.08333 15.5 7.5 15.5C7.91667 15.5 8.33333 15.4583 8.75 15.375V10.0833H10.4167Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_619_32901",
  x1: 7.5,
  y1: 14.9808,
  x2: 7.5,
  y2: 0.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0062E0"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#19AFFF"
})));

function SvgFacebookLogoSmall(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogoSmall);
export default __webpack_public_path__ + "static/media/facebook-logo-small.4b918f72.svg";
export { ForwardRef as ReactComponent };